import { IShipmentStopSequenceInput } from 'types/graphqlTypes'
import { IOrderedShipmentStopFragment } from '../../graphql/OrderedShipmentStop'
import { IRearrangeShipmentStopsMutationVariables } from '../../graphql/RearrangeShipmentStops'

/**
 * Creates API query input format from array
 */
export const mapToSequenceInput = (
  stops: Pick<IOrderedShipmentStopFragment, 'id'>[]
): IShipmentStopSequenceInput[] => {
  return stops.map(({ id }, arrayIndex) => ({
    sequenceNumber: arrayIndex + 1,
    shipmentStopId: id,
  }))
}

/**
 * Creates request body from input
 */
export const getStopsInput = (
  pickupStops: Pick<IOrderedShipmentStopFragment, 'id'>[],
  deliveryStops: Pick<IOrderedShipmentStopFragment, 'id'>[],
  clientMutationId?: string
): IRearrangeShipmentStopsMutationVariables['input'] => {
  return {
    clientMutationId,
    pickupStopsSequence: mapToSequenceInput(pickupStops),
    deliveryStopsSequence: mapToSequenceInput(deliveryStops),
  }
}
